import React, { useState } from "react";
import "./index.scss";

const FAQ = () => {
  const [faqs, setFaqs] = useState([
    {
      question: "Qu'est-ce que la fondation Junior ?",
      answer:
        "La fondation Junior est une organisation à but non lucratif dédiée à améliorer l'éducation et la nutrition des enfants et des familles en Afrique. Nous travaillons avec des partenaires locaux pour fournir des ressources essentielles et des programmes de soutien.",
      open: true,
    },
    {
      question: "Quels sont les objectifs de la fondation ?",
      answer: "La Fondation Junior vise à lutter contre la malnutrition, fournir de l'eau potable, améliorer l'éducation et renforcer l'autonomie des populations rurales en mettant en place des projets durables.",
      open: false,
    },
    {
      question: "Quels types de projets financez-vous ?",
      answer: "Nous finançons des projets visant à améliorer la sécurité alimentaire, l'accès à l'eau potable, les infrastructures éducatives et sanitaires, ainsi que l'autonomisation des femmes.",
      open: false,
    },
    {
      question: "Comment puis-je soutenir la fondation Junior ?",
      answer: "Vous pouvez soutenir la fondation en faisant un don en ligne, en organisant des collectes de fonds, ou en vous impliquant dans nos projets en tant que bénévole.",
      open: false,
    },
    {
      question: "Comment mes dons sont-ils utilisés ?",
      answer: "Chaque don est directement affecté aux projets de terrain, tels que la construction de puits, la distribution de vivres, et l'amélioration des infrastructures. Nous garantissons une gestion transparente des fonds.",
      open: false,
    },
    {
      question: "Qui sont les bénéficiaires de vos programmes ?",
      answer: "Nos programmes bénéficient principalement aux enfants, aux femmes et aux familles vivant en milieu rural, particulièrement celles dans les zones les plus reculées et démunies.",
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <section className="faq-section">
      <div className="faq-decoration-left"></div>
      <div className="faq-decoration-right"></div>
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title">FAQ</h1>
          <h2 className="faq-subtitle">
            Trouvez ici toutes les réponses à vos questions sur nos programmes
            d'éducation et de nutrition en Afrique.
          </h2>
        </div>

        <div className="faqs">
          {faqs.map((faq, index) => (
            <div
              className={"faq " + (faq.open ? "open" : "")}
              key={index}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">{faq.question}</div>
              <div className="faq-answer">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
